module.exports = __webpack_public_path__ + "static/media/editNew.818f69ed.svg";